define('modules/form_editor/views/editor_hidden',['require','exports','module','base/view','ldsh!../templates/editor_hidden'],function(require, exports, module){
  "use strict";
  var BaseView = require("base/view");
  module.exports = BaseView.extend({
    template: require("ldsh!../templates/editor_hidden"),
    events: {
      "change .js-value": "updateModel",
      "change .js-variable": "updateVariable"
    },
    updateModel: function(e){
      e.preventDefault();
      this.model.set("value", $(e.currentTarget).val().trim());
    },
    updateVariable: function(e){
      e.preventDefault();
      this.model.set("variable", $(e.currentTarget).val().trim());
    },
    onRender: function(){
      this.$el.i18n();
    }
  });
});

